import React from 'react'
import { blue, red, yellow, green } from '@mui/material/colors';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { ChargeDispute, Patient } from '../../../../../models';
import dayjs from 'dayjs';
import Centered from '../../../../../components/Centered';
import PatientListWidget from '../../patients/patients-list.component';
import { titleCase } from '../../../../../helpers';
import AppLink from "../../../../../components/AppLink";
import { ROUTES } from '../../../../../history';


const ChargeDisputeView: React.FC<
    {
        chargedispute: ChargeDispute;
        patient: Patient
    }
> = ({
    chargedispute,
    patient
}) => {
    const name = titleCase(`${patient.FirstName} ${patient.LastName}`)

        const getColor = (): string => {
            let color: string;
            switch (chargedispute.status) {
                case "Scheduled":
                    color = blue[700];
                    break;
                case "Cancelled":
                    color = red[700];
                    break;
                case "Completed":
                    color = green[700];
                    break;
                default:
                    color = yellow[800]
                    break;
            }
            return color;

        }

        return (
            <Centered >
                <Paper style={{
                    padding: '1em',
                    borderRadius: '14px',
                    border: 'none',
                    width:'80%',

                    maxWidth: '450px',

                }} elevation={2} >
                    <Typography textAlign={'center'} fontWeight="bold"
                        component="h6" variant="h6">
                        Opened by {name}
                    </Typography>
                    <Typography variant='subtitle1' fontSize={'14px'}  color={'#6B779A'} textAlign={'center'} sx={{
                        mt: 1,

                    }}>

                        {dayjs(chargedispute.createdAt).format("ddd MMM D, HH:mm")}
                    </Typography>
      

                    <Typography variant='subtitle1' color={getColor()} textAlign={'center'} sx={{
                        mt: 1,
                        mb: 2,

                    }}

                    >
                        {chargedispute.status}
                    </Typography>
                    <div style={{
                        padding: '1em',
                        borderRadius: '24px',
                        backgroundColor: '#F8F8FA',
                        marginBottom: '2em'
                    }}>
                        <Typography fontWeight={'bold'}>
                        Patient Description
                        </Typography>

                        <Typography variant='subtitle1' color={'#6B779A'}>
                            {chargedispute.body}
                        </Typography>
                    </div>




                    <div>
                        <Typography fontWeight={'bold'}>
                            Patient
                        </Typography>
                        <PatientListWidget patient={patient} />
                    </div>

                    {chargedispute.status === 'Pending' ? (        <Box mt={3}>
          <AppLink
            doNotUseButton
            to={
              ROUTES.ADMIN_BASE + "/refunds/charge-disputes/resolve/" + chargedispute.id
            }
          >
            <Button color="success">Resolve</Button>
            
          </AppLink>
     
         
        </Box>): null}
                </Paper >
            </Centered>
        )
    }

export default ChargeDisputeView